<template>
  <div class="fu-drtab" data-test="fu-drawer-appointments">
    <section v-for="g in groups" :key="g.key" :data-test="`fu-drawer-appts-${g.key}`">
      <div class="fu-drtab__title">{{ g.title }}<span>{{ g.items.length }}</span></div>
      <p v-if="!g.items.length" class="fu-drtab__none">{{ g.empty }}</p>
      <div v-for="(it, i) in g.items" :key="i" class="fu-drtab__item">
        <div v-if="it.chip" class="fu-drtab__chip"><span>{{ it.chip.mon }}</span><strong>{{ it.chip.day }}</strong><small>{{ it.chip.yr }}</small></div>
        <div class="fu-drtab__main">
          <div class="fu-drtab__item-title">{{ it.title }}</div>
          <div v-if="it.meta" class="fu-drtab__meta">{{ it.meta }}</div>
          <div v-if="it.note" class="fu-drtab__note">{{ it.note }}</div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
/**
 * DrawerAppointmentsTab — "Appointments": today's Scheduled / Planned / Past appointment tabs as
 * sections (recall: scheduled + past; unscheduled treatment: planned + scheduled). Fields as today:
 * ProcDescript, Provider, AptDateTime / AppointmentDate, AppointmentNotes / Note. Presentational.
 */
import { dateChipOf } from '@/utils/followups/drawer/drawerFacts.js';

const TITLES = { scheduled: 'Scheduled', planned: 'Planned', past: 'Past' };
const EMPTY = { scheduled: 'No scheduled appointments.', planned: 'No planned appointments.', past: 'No past appointments.' };

export default {
  name: 'DrawerAppointmentsTab',
  props: {
    tab: { type: Object, required: true },
    ctx: { type: Object, required: true },
  },
  computed: {
    groups() {
      return (this.tab.sections || []).map((s) => {
        const rows = s.rows || [];
        return {
          key: s.key,
          title: TITLES[s.key] || s.legacyTitle,
          empty: EMPTY[s.key] || 'None.',
          items: rows.map((a) => {
            const date = s.key === 'past' ? a.AppointmentDate : a.AptDateTime;
            return {
              chip: dateChipOf(date),
              title: a.ProcDescript || 'Appointment',
              meta: [a.Provider].filter(Boolean).join(' · '),
              note: s.key === 'planned' ? a.Note : a.AppointmentNotes,
            };
          }),
        };
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import './drawer';

.fu-drtab__title { @include fu-dr-section-title; span { color: $fu-text-subtle; } }
.fu-drtab__none { margin: 0; padding: 12px 0; font-size: 13px; color: $fu-text-subtle; border-bottom: 1px solid $fu-border; }
.fu-drtab__item { @include fu-dr-item; }
.fu-drtab__main { flex: 1; min-width: 0; }
.fu-drtab__item-title { @include fu-dr-item-title; }
.fu-drtab__meta { @include fu-dr-item-meta; }
.fu-drtab__note { margin-top: 5px; font-size: 12.5px; line-height: 1.45; color: $fu-neutral-600; overflow-wrap: anywhere; }

.fu-drtab__chip {
  @include fu-dr-date-chip;
  span { display: block; font-size: 10px; font-weight: $fu-fw-bold; letter-spacing: 0.06em; text-transform: uppercase; color: $fu-brand-600; }
  strong { display: block; font-size: 16px; font-weight: 800; }
  small { display: block; font-size: 10px; color: $fu-text-subtle; }
}
</style>
